import { gql } from '@apollo/client';

export interface IValidatePromoCodeRequest {
  input: {
    code: string;
    client_id?: string;
    items?: {
      type: EValidatePromoCodeItemsType;
      entity_id: number;
    }[];
  };
}

export enum EValidatePromoCodeItemsType {
  DEPOSIT = 'DEPOSIT',
  GOOD = 'GOOD',
  SERVICE = 'SERVICE',
  TARIFF = 'TARIFF',
  COMBO = 'COMBO',
  BONUS = 'BONUS',
  TIPS = 'TIPS',
}

export interface IValidatePromoCodeResponse {
  validatePromoCode: {
    items: {
      entity_id: number;
      entity_type: EValidatePromoCodeItemsType;
    }[];
    promo_code: {
      code: string;
      id: number;
      value: {
        type: 'DISCOUNT' | 'DEPOSIT' | 'BONUS';
        value: number;
        currency: {
          alias: string;
        };
      };
    };
  };
}
export const VALIDATE_PROMO_CODE = gql`
  query validatePromoCodeV2($input: ValidatePromoCodeInput!) {
    validatePromoCode(input: $input) {
      items {
        entity_id
        entity_type
      }
      promo_code {
        code
        id
        value {
          value
          type
          currency {
            alias
          }
        }
      }
    }
  }
`;
